import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const CardiometabolicNitricOxideDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const dhfr = getGenePalette(geneColors.DHFR);
  const nos3 = getGenePalette(geneColors.NOS3);
  const sod1_3 = getGenePalette(geneColors["SOD1/3"]);
  const gpx1 = getGenePalette(geneColors.GPX1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_231791)">
        <rect width={1424} height={869} transform="translate(0 204)" fill="white" />
        <g id="methylation-nitric-oxide-diagram">
          <rect width={1424} height={869} transform="translate(0 204)" fill="white" />
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M313 284.042L320 288.083V280L313 284.042ZM478.3 284.742H479V283.342H478.3V284.042V284.742ZM319.3 284.042V284.742L478.3 284.742V284.042V283.342L319.3 283.342V284.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_3">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
              id="Line Label"
              transform="translate(697 536)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={71.9385} y={16.767}>
                Decrease BH4
              </tspan>
            </text>
            <path
              id="Vector_4"
              d="M697.7 563.7L931.3 563.7"
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeLinecap="round"
              strokeDasharray="4 4"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_5"
              d="M561 284.042L568 288.083V280L561 284.042ZM627.3 284.742H628V283.342H627.3V284.042V284.742ZM567.3 284.042V284.742H627.3V284.042V283.342H567.3V284.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_6"
              d="M712 284.042L719 288.083V280L712 284.042ZM794.3 284.742H795V283.342H794.3V284.042V284.742ZM718.3 284.042V284.742H794.3V284.042V283.342H718.3V284.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_6">
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
              id="Line Label_2"
              transform="translate(248 408) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={18.666} y={16.767}>
                Removes
              </tspan>
            </text>
            <path
              id="Vector_7"
              d="M278.342 407.3L278.342 408L279.742 408L279.742 407.3L279.042 407.3L278.342 407.3ZM279.041 313L275 320L283.083 320L279.041 313ZM279.042 407.3L279.742 407.3L279.742 319.3L279.042 319.3L278.342 319.3L278.342 407.3L279.042 407.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_8"
              d="M1107.74 533.7L1107.74 533L1106.34 533L1106.34 533.7L1107.04 533.7L1107.74 533.7ZM1107.04 611L1111.08 604L1103 604L1107.04 611ZM1107.04 533.7L1106.34 533.7L1106.34 604.7L1107.04 604.7L1107.74 604.7L1107.74 533.7L1107.04 533.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_9"
              d="M274.742 611.7C274.742 611.314 274.428 611 274.042 611C273.655 611 273.342 611.314 273.342 611.7L274.042 611.7L274.742 611.7ZM274.042 669L278.083 662L270 662L274.042 669ZM273.342 613.747C273.342 614.133 273.655 614.447 274.042 614.447C274.428 614.447 274.742 614.133 274.742 613.747L274.042 613.747L273.342 613.747ZM274.742 617.839C274.742 617.453 274.428 617.139 274.042 617.139C273.655 617.139 273.342 617.453 273.342 617.839L274.042 617.839L274.742 617.839ZM273.342 621.932C273.342 622.319 273.655 622.632 274.042 622.632C274.428 622.632 274.742 622.319 274.742 621.932L274.042 621.932L273.342 621.932ZM274.742 626.025C274.742 625.639 274.428 625.325 274.042 625.325C273.655 625.325 273.342 625.639 273.342 626.025L274.042 626.025L274.742 626.025ZM273.342 630.118C273.342 630.505 273.655 630.818 274.042 630.818C274.428 630.818 274.742 630.505 274.742 630.118L274.042 630.118L273.342 630.118ZM274.742 634.211C274.742 633.824 274.428 633.511 274.042 633.511C273.655 633.511 273.342 633.824 273.342 634.211L274.042 634.211L274.742 634.211ZM273.342 638.304C273.342 638.69 273.655 639.004 274.042 639.004C274.428 639.004 274.742 638.69 274.742 638.304L274.042 638.304L273.342 638.304ZM274.742 642.397C274.742 642.01 274.428 641.697 274.042 641.697C273.655 641.697 273.342 642.01 273.342 642.397L274.042 642.397L274.742 642.397ZM273.342 646.489C273.342 646.876 273.655 647.189 274.042 647.189C274.428 647.189 274.742 646.876 274.742 646.489L274.042 646.489L273.342 646.489ZM274.742 650.582C274.742 650.196 274.428 649.882 274.042 649.882C273.655 649.882 273.342 650.196 273.342 650.582L274.042 650.582L274.742 650.582ZM273.342 654.675C273.342 655.062 273.655 655.375 274.042 655.375C274.428 655.375 274.742 655.062 274.742 654.675L274.042 654.675L273.342 654.675ZM274.742 658.768C274.742 658.381 274.428 658.068 274.042 658.068C273.655 658.068 273.342 658.381 273.342 658.768L274.042 658.768L274.742 658.768ZM273.342 662.861C273.342 663.248 273.655 663.561 274.042 663.561C274.428 663.561 274.742 663.248 274.742 662.861L274.042 662.861L273.342 662.861ZM274.742 666.954C274.742 666.567 274.428 666.254 274.042 666.254C273.655 666.254 273.342 666.567 273.342 666.954L274.042 666.954L274.742 666.954ZM274.042 611.7L273.342 611.7L273.342 613.747L274.042 613.747L274.742 613.747L274.742 611.7L274.042 611.7ZM274.042 617.839L273.342 617.839L273.342 621.932L274.042 621.932L274.742 621.932L274.742 617.839L274.042 617.839ZM274.042 626.025L273.342 626.025L273.342 630.118L274.042 630.118L274.742 630.118L274.742 626.025L274.042 626.025ZM274.042 634.211L273.342 634.211L273.342 638.304L274.042 638.304L274.742 638.304L274.742 634.211L274.042 634.211ZM274.042 642.397L273.342 642.397L273.342 646.489L274.042 646.489L274.742 646.489L274.742 642.397L274.042 642.397ZM274.042 650.582L273.342 650.582L273.342 654.675L274.042 654.675L274.742 654.675L274.742 650.582L274.042 650.582ZM274.042 658.768L273.342 658.768L273.342 662.861L274.042 662.861L274.742 662.861L274.742 658.768L274.042 658.768Z"
              fill="#818181"
            />
          </g>
          <g id="Cofactor_3">
            <g id="diamond_2">
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={1131.18} y={564.086}>
                  NADPH
                </tspan>
              </text>
              <g id="Vector_10">
                <mask id="path-33-inside-2_18293_231791" fill="white">
                  <path d="M1151 535L1176 547.121V572.879L1151 585L1126 572.879V547.121L1151 535Z" />
                </mask>
                <path
                  d="M1151 535L1176 547.121V572.879L1151 585L1126 572.879V547.121L1151 535Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-33-inside-2_18293_231791)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_4">
            <g id="diamond_3">
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={327.909} y={733.767}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_11">
                <mask id="path-35-inside-3_18293_231791" fill="white">
                  <path d="M341 704L366 716.121V741.879L341 754L316 741.879V716.121L341 704Z" />
                </mask>
                <path
                  d="M341 704L366 716.121V741.879L341 754L316 741.879V716.121L341 704Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-35-inside-3_18293_231791)"
                />
              </g>
            </g>
          </g>
          <g id="Report titles">
            <rect width={39} height={28} transform="translate(253 263)" fill="white" />
            <g id="25-Hydroxy Vitamin D">
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={253.371} y={283.129}>
                  H
                </tspan>
                <tspan x={271.537} y={283.129}>
                  O
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={265.518} y={283.129}>
                  ₂
                </tspan>
                <tspan x={285.933} y={283.129}>
                  ₂
                </tspan>
              </text>
            </g>
          </g>
          <g id="Report titles_2">
            <rect width={79} height={52} transform="translate(628 263)" fill="white" />
            <g id="25-Hydroxy Vitamin D_2">
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={651.109} y={283.129}>
                  O
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={665.506} y={283.129}>
                  ₂
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={674.549} y={283.129}>
                  •⁻
                </tspan>
              </text>
            </g>
            <text
              fontFamily="Gilroy W05 Regular"
              fontSize={14}
              letterSpacing="0em"
              id="Sub Label"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={628.446} y={307.76}>
                Superoxides
              </tspan>
            </text>
          </g>
          <text
            fontFamily="Gilroy W05 Regular"
            fontSize={16}
            letterSpacing="0em"
            id="Toxic"
            fill="#E44C4B"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
          >
            <tspan x={739.188} y={303.44}>
              Toxic
            </tspan>
          </text>
          <g id="Report titles_3">
            <text
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D_3"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={1198.86} y={467.12}>
                Folic Acid{" "}
              </tspan>
              <tspan x={1195.29} y={495.12}>
                and folate
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <text
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D_4"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={1091.27} y={471.12}>
                DHF
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <text
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D_5"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={810.274} y={428.12}>
                STRESS
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <text
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D_6"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={1091.39} y={632.12}>
                THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={105} height={20} transform="translate(795 232)" fill="white" />
            <text
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
              id="25-Hydroxy Vitamin D_7"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={795.094} y={246.08}>
                Uncoupled Enzyme
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect x={511.7} y={352.7} width={235.6} height={226.6} fill="white" />
            <rect
              x={511.7}
              y={352.7}
              width={235.6}
              height={226.6}
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <text
              fontFamily="Gilroy W05 Regular"
              fontSize={16}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D_8"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={527} y={387.44}>
                BPA{" "}
              </tspan>
              <tspan x={527} y={415.44}>
                Smoking{" "}
              </tspan>
              <tspan x={527} y={443.44}>
                Aluminium{" "}
              </tspan>
              <tspan x={527} y={471.44}>
                Chemotherapy{" "}
              </tspan>
              <tspan x={527} y={499.44}>
                Perfluorinated substances{" "}
              </tspan>
              <tspan x={527} y={527.44}>
                Chronic viral infections (long{" "}
              </tspan>
              <tspan x={527} y={555.44}>
                COVID, hepatitis etc.)
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={49} height={28} transform="translate(939 360)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D_9"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={947.144} y={380.129}>
                BH2
              </tspan>
            </text>
          </g>
          <g id="report-label">
            <g id="Report titles_10">
              <rect width={66} height={28} transform="translate(242 672)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
                id="25-Hydroxy Vitamin D_10"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={242.05} y={692.12}>
                  Arginine
                </tspan>
              </text>
            </g>
            <g id="lines_9">
              <path
                id="Vector_12"
                d="M275.658 704.7L275.658 704L274.258 704L274.258 704.7L274.958 704.7L275.658 704.7ZM274.958 825L279 818L270.917 818L274.958 825ZM274.958 704.7L274.258 704.7L274.258 818.7L274.958 818.7L275.658 818.7L275.658 704.7L274.958 704.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_2">
            <g id="Report titles_11">
              <rect width={137} height={28} transform="translate(206 827)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
                id="25-Hydroxy Vitamin D_11"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={206.446} y={847.12}>
                  Nitric Oxide (NO)
                </tspan>
              </text>
            </g>
            <g id="lines_10">
              <path
                id="Vector_13"
                d="M275.158 859.7C275.158 859.314 274.845 859 274.458 859C274.072 859 273.758 859.314 273.758 859.7L274.458 859.7L275.158 859.7ZM274.458 970L278.5 963L270.417 963L274.458 970ZM273.758 861.67C273.758 862.056 274.072 862.37 274.458 862.37C274.845 862.37 275.158 862.056 275.158 861.67L274.458 861.67L273.758 861.67ZM275.158 865.609C275.158 865.223 274.845 864.909 274.458 864.909C274.072 864.909 273.758 865.223 273.758 865.609L274.458 865.609L275.158 865.609ZM273.758 869.548C273.758 869.935 274.072 870.248 274.458 870.248C274.845 870.248 275.158 869.935 275.158 869.548L274.458 869.548L273.758 869.548ZM275.158 873.488C275.158 873.101 274.845 872.788 274.458 872.788C274.072 872.788 273.758 873.101 273.758 873.488L274.458 873.488L275.158 873.488ZM273.758 877.427C273.758 877.814 274.072 878.127 274.458 878.127C274.845 878.127 275.158 877.814 275.158 877.427L274.458 877.427L273.758 877.427ZM275.158 881.366C275.158 880.98 274.845 880.666 274.458 880.666C274.072 880.666 273.758 880.98 273.758 881.366L274.458 881.366L275.158 881.366ZM273.758 885.306C273.758 885.692 274.072 886.006 274.458 886.006C274.845 886.006 275.158 885.692 275.158 885.306L274.458 885.306L273.758 885.306ZM275.158 889.245C275.158 888.858 274.845 888.545 274.458 888.545C274.072 888.545 273.758 888.858 273.758 889.245L274.458 889.245L275.158 889.245ZM273.758 893.184C273.758 893.571 274.072 893.884 274.458 893.884C274.845 893.884 275.158 893.571 275.158 893.184L274.458 893.184L273.758 893.184ZM275.158 897.123C275.158 896.737 274.845 896.423 274.458 896.423C274.072 896.423 273.758 896.737 273.758 897.123L274.458 897.123L275.158 897.123ZM273.758 901.063C273.758 901.449 274.072 901.763 274.458 901.763C274.845 901.763 275.158 901.449 275.158 901.063L274.458 901.063L273.758 901.063ZM275.158 905.002C275.158 904.615 274.845 904.302 274.458 904.302C274.072 904.302 273.758 904.615 273.758 905.002L274.458 905.002L275.158 905.002ZM273.758 908.941C273.758 909.328 274.072 909.641 274.458 909.641C274.845 909.641 275.158 909.328 275.158 908.941L274.458 908.941L273.758 908.941ZM275.158 912.881C275.158 912.494 274.845 912.181 274.458 912.181C274.072 912.181 273.758 912.494 273.758 912.881L274.458 912.881L275.158 912.881ZM273.758 916.82C273.758 917.206 274.072 917.52 274.458 917.52C274.845 917.52 275.158 917.206 275.158 916.82L274.458 916.82L273.758 916.82ZM275.158 920.759C275.158 920.373 274.845 920.059 274.458 920.059C274.072 920.059 273.758 920.373 273.758 920.759L274.458 920.759L275.158 920.759ZM273.758 924.698C273.758 925.085 274.072 925.398 274.458 925.398C274.845 925.398 275.158 925.085 275.158 924.698L274.458 924.698L273.758 924.698ZM275.158 928.638C275.158 928.251 274.845 927.938 274.458 927.938C274.072 927.938 273.758 928.251 273.758 928.638L274.458 928.638L275.158 928.638ZM273.758 932.577C273.758 932.964 274.072 933.277 274.458 933.277C274.845 933.277 275.158 932.964 275.158 932.577L274.458 932.577L273.758 932.577ZM275.158 936.516C275.158 936.13 274.845 935.816 274.458 935.816C274.072 935.816 273.758 936.13 273.758 936.516L274.458 936.516L275.158 936.516ZM273.758 940.456C273.758 940.842 274.072 941.156 274.458 941.156C274.845 941.156 275.158 940.842 275.158 940.456L274.458 940.456L273.758 940.456ZM275.158 944.395C275.158 944.008 274.845 943.695 274.458 943.695C274.072 943.695 273.758 944.008 273.758 944.395L274.458 944.395L275.158 944.395ZM273.758 948.334C273.758 948.721 274.072 949.034 274.458 949.034C274.845 949.034 275.158 948.721 275.158 948.334L274.458 948.334L273.758 948.334ZM275.158 952.273C275.158 951.887 274.845 951.573 274.458 951.573C274.072 951.573 273.758 951.887 273.758 952.273L274.458 952.273L275.158 952.273ZM273.758 956.213C273.758 956.599 274.072 956.913 274.458 956.913C274.845 956.913 275.158 956.599 275.158 956.213L274.458 956.213L273.758 956.213ZM275.158 960.152C275.158 959.765 274.845 959.452 274.458 959.452C274.072 959.452 273.758 959.765 273.758 960.152L274.458 960.152L275.158 960.152ZM273.758 964.091C273.758 964.478 274.072 964.791 274.458 964.791C274.845 964.791 275.158 964.478 275.158 964.091L274.458 964.091L273.758 964.091ZM275.158 968.031C275.158 967.644 274.845 967.331 274.458 967.331C274.072 967.331 273.758 967.644 273.758 968.031L274.458 968.031L275.158 968.031ZM274.458 859.7L273.758 859.7L273.758 861.67L274.458 861.67L275.158 861.67L275.158 859.7L274.458 859.7ZM274.458 865.609L273.758 865.609L273.758 869.548L274.458 869.548L275.158 869.548L275.158 865.609L274.458 865.609ZM274.458 873.488L273.758 873.488L273.758 877.427L274.458 877.427L275.158 877.427L275.158 873.488L274.458 873.488ZM274.458 881.366L273.758 881.366L273.758 885.306L274.458 885.306L275.158 885.306L275.158 881.366L274.458 881.366ZM274.458 889.245L273.758 889.245L273.758 893.184L274.458 893.184L275.158 893.184L275.158 889.245L274.458 889.245ZM274.458 897.123L273.758 897.123L273.758 901.063L274.458 901.063L275.158 901.063L275.158 897.123L274.458 897.123ZM274.458 905.002L273.758 905.002L273.758 908.941L274.458 908.941L275.158 908.941L275.158 905.002L274.458 905.002ZM274.458 912.881L273.758 912.881L273.758 916.82L274.458 916.82L275.158 916.82L275.158 912.881L274.458 912.881ZM274.458 920.759L273.758 920.759L273.758 924.698L274.458 924.698L275.158 924.698L275.158 920.759L274.458 920.759ZM274.458 928.638L273.758 928.638L273.758 932.577L274.458 932.577L275.158 932.577L275.158 928.638L274.458 928.638ZM274.458 936.516L273.758 936.516L273.758 940.456L274.458 940.456L275.158 940.456L275.158 936.516L274.458 936.516ZM274.458 944.395L273.758 944.395L273.758 948.334L274.458 948.334L275.158 948.334L275.158 944.395L274.458 944.395ZM274.458 952.273L273.758 952.273L273.758 956.213L274.458 956.213L275.158 956.213L275.158 952.273L274.458 952.273ZM274.458 960.152L273.758 960.152L273.758 964.091L274.458 964.091L275.158 964.091L275.158 960.152L274.458 960.152Z"
                fill="#818181"
              />
            </g>
          </g>
          <g id="Frame 466">
            <path
              d="M353 978V978.7H355C355.756 978.7 356.493 978.774 357.206 978.915L357.341 978.229C358.915 978.54 360.378 979.16 361.666 980.021L361.278 980.603C362.511 981.428 363.572 982.489 364.397 983.722L364.978 983.333C365.84 984.621 366.459 986.084 366.771 987.658L366.085 987.794C366.226 988.507 366.3 989.244 366.3 990V991.667H367V995H366.3V998.333H367V1001.67H366.3V1005H367V1008.33H366.3V1010C366.3 1010.76 366.226 1011.49 366.085 1012.21L366.771 1012.34C366.459 1013.92 365.84 1015.38 364.978 1016.67L364.397 1016.28C363.572 1017.51 362.511 1018.57 361.278 1019.4L361.666 1019.98C360.378 1020.84 358.915 1021.46 357.341 1021.77L357.206 1021.08C356.493 1021.23 355.756 1021.3 355 1021.3H353V1022H349V1021.3H345V1022H341V1021.3H337V1022H333V1021.3H329V1022H325V1021.3H321V1022H317V1021.3H313V1022H309V1021.3H305V1022H301V1021.3H297V1022H293V1021.3H289V1022H285V1021.3H281V1022H277V1021.3H273V1022H269V1021.3H265V1022H261V1021.3H257V1022H253V1021.3H249V1022H245V1021.3H241V1022H237V1021.3H233V1022H229V1021.3H225V1022H221V1021.3H217V1022H213V1021.3H209V1022H205V1021.3H201V1022H197V1021.3H195C194.244 1021.3 193.507 1021.23 192.794 1021.08L192.658 1021.77C191.084 1021.46 189.621 1020.84 188.333 1019.98L188.722 1019.4C187.489 1018.57 186.428 1017.51 185.603 1016.28L185.021 1016.67C184.16 1015.38 183.54 1013.92 183.229 1012.34L183.915 1012.21C183.809 1011.67 183.741 1011.12 183.714 1010.56L183.7 1010V1008.33H183V1005H183.7V1001.67H183V998.333H183.7V995H183V991.667H183.7V990C183.7 989.244 183.774 988.507 183.915 987.794L183.229 987.658C183.54 986.084 184.16 984.621 185.021 983.333L185.603 983.722C186.428 982.489 187.489 981.428 188.722 980.603L188.333 980.021C189.621 979.16 191.084 978.54 192.658 978.229L192.794 978.915C193.507 978.774 194.244 978.7 195 978.7H197V978H201V978.7H205V978H209V978.7H213V978H217V978.7H221V978H225V978.7H229V978H233V978.7H237V978H241V978.7H245V978H249V978.7H253V978H257V978.7H261V978H265V978.7H269V978H273V978.7H277V978H281V978.7H285V978H289V978.7H293V978H297V978.7H301V978H305V978.7H309V978H313V978.7H317V978H321V978.7H325V978H329V978.7H333V978H337V978.7H341V978H345V978.7H349V978H353Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block">
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={199.445} y={1005.45}>
                  Healthy vasodilation
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Ellipse 10"
            d="M1114.97 449L1119.52 445.451L1114.17 443.282L1114.97 449ZM1116.66 444.832L1117.11 445.036C1127.25 422.326 1150.03 406.5 1176.5 406.5V406V405.5C1149.62 405.5 1126.49 421.572 1116.2 444.629L1116.66 444.832ZM1176.5 406V406.5C1204.55 406.5 1228.46 424.271 1237.56 449.172L1238.03 449L1238.5 448.828C1229.26 423.546 1204.99 405.5 1176.5 405.5V406Z"
            fill="#282828"
          />
          <path
            id="Vector 431"
            d="M274 610H802.257L931 567"
            stroke="#818181"
            strokeWidth={1.4}
            strokeDasharray="4 4"
          />
          <g id="report-label_3">
            <g id="Report titles_12">
              <rect width={64} height={28} transform="translate(142 799)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={16}
                letterSpacing="0em"
                id="25-Hydroxy Vitamin D_12"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={142.336} y={818.44}>
                  Citrulline
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_4">
            <g id="Report titles_13">
              <rect width={124} height={28} transform="translate(292 793)" fill="white" />
              <text
                fontFamily="Gilroy W05 Regular"
                fontSize={16}
                letterSpacing="0em"
                id="25-Hydroxy Vitamin D_13"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={292.32} y={812.44}>
                  Coupled Enzyme
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Ellipse 9"
            d="M988 562L995.847 563.937L993.601 556.172L988 562ZM1059 471H1058.3C1058.3 512.329 1031.27 547.378 993.84 559.582L994.057 560.248L994.274 560.913C1032.26 548.528 1059.7 512.956 1059.7 471H1059ZM988 380L987.828 380.679C1028.34 390.939 1058.3 427.49 1058.3 471H1059H1059.7C1059.7 426.829 1029.29 389.734 988.172 379.321L988 380Z"
            fill="#282828"
          />
          <path
            id="Vector 432"
            d="M217 820L224.313 823.443L223.638 815.389L217 820ZM271 797L270.443 796.576C265.61 802.919 249.666 815.722 223.198 818.779L223.278 819.474L223.359 820.17C250.181 817.072 266.479 804.089 271.557 797.424L271 797Z"
            fill="#282828"
          />
          <path
            id="Ellipse 8"
            d="M938 381L930.081 379.383L932.64 387.05L938 381ZM936.35 561L936.561 560.333C898.968 548.427 871.7 513.048 871.7 471.253H871H870.3C870.3 513.67 897.975 549.581 936.138 561.667L936.35 561ZM871 471.253H871.7C871.7 431.067 896.91 396.812 932.268 383.651L932.024 382.995L931.779 382.339C895.886 395.699 870.3 430.468 870.3 471.253H871Z"
            fill="#282828"
          />
          <path id="Vector 430" d="M900 284H963V362" stroke="#E44C4B" strokeWidth={1.4} />
          <g id="Report titles_14">
            <rect width={50} height={28} transform="translate(939 544)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
              id="25-Hydroxy Vitamin D_14"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
            >
              <tspan x={947.169} y={564.129}>
                BH4
              </tspan>
            </text>
          </g>
          <g id="gene-DHFR" {...geneGroupProps("DHFR", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M1055 491C1055 488.791 1056.79 487 1059 487H1151C1153.21 487 1155 488.791 1155 491V519C1155 521.209 1153.21 523 1151 523H1059C1056.79 523 1055 521.209 1055 519V491Z"
                fill={dhfr.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
                id="gene-lozenge-label"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={1084.84} y={510.448}>
                  DHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="dhfr"
              groupId="gene-snps"
              genePalette={dhfr}
              startX={1063}
              startY={525}
              snpCount={getGeneSnpCount("DHFR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NOS3" {...geneGroupProps("NOS3", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M225 751C225 748.791 226.791 747 229 747H321C323.209 747 325 748.791 325 751V779C325 781.209 323.209 783 321 783H229C226.791 783 225 781.209 225 779V751Z"
                fill={nos3.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
                id="gene-lozenge-label_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={254.477} y={770.448}>
                  NOS3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nos3"
              groupId="gene-snps_2"
              genePalette={nos3}
              startX={233}
              startY={785}
              snpCount={getGeneSnpCount("NOS3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NOS3_2" {...geneGroupProps("NOS3", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M795 269C795 266.791 796.791 265 799 265H891C893.209 265 895 266.791 895 269V297C895 299.209 893.209 301 891 301H799C796.791 301 795 299.209 795 297V269Z"
                fill={nos3.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
                id="gene-lozenge-label_3"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={824.477} y={288.448}>
                  NOS3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nos3-2"
              groupId="gene-snps_3"
              genePalette={nos3}
              startX={803}
              startY={303}
              snpCount={getGeneSnpCount("NOS3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SOD1/3" {...geneGroupProps("SOD1/3", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M461 269C461 266.791 462.791 265 465 265H557C559.209 265 561 266.791 561 269V297C561 299.209 559.209 301 557 301H465C462.791 301 461 299.209 461 297V269Z"
                fill={sod1_3.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
                id="gene-lozenge-label_4"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={482.992} y={288.448}>
                  SOD1/3
                </tspan>
              </text>
              <path
                id="*_3"
                d="M571.748 261.406V263.824L567.818 263.695L570.064 266.934L567.861 268.23L565.874 264.731L563.887 268.23L561.684 266.934L563.93 263.695L560 263.824L560 261.406L563.93 261.535L561.684 258.296L563.887 257L565.874 260.499L567.861 257L570.064 258.296L567.818 261.535L571.748 261.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="sod1-3"
              groupId="gene-snps_4"
              genePalette={sod1_3}
              startX={469}
              startY={303}
              snpCount={getGeneSnpCount("SOD1/3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-GPX1" {...geneGroupProps("GPX1", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M229 418C229 415.791 230.791 414 233 414H325C327.209 414 329 415.791 329 418V446C329 448.209 327.209 450 325 450H233C230.791 450 229 448.209 229 446V418Z"
                fill={gpx1.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
                id="gene-lozenge-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
              >
                <tspan x={260.656} y={437.448}>
                  GPX1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="gpx1"
              groupId="gene-snps_5"
              genePalette={gpx1}
              startX={237}
              startY={452}
              snpCount={getGeneSnpCount("GPX1", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgCardiometabolicNitricOxideDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1424}
    height={869}
    viewBox="0 204 1424 869"
    fill="none"
    {...props}
  >
    <CardiometabolicNitricOxideDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_231791">
        <rect width={1424} height={1073} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_231791">
        <rect width={1424} height={869} fill="white" transform="translate(0 204)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCardiometabolicNitricOxideDiagram;
